import { render, staticRenderFns } from "./Emailer.vue?vue&type=template&id=38bb24fe&"
import script from "./Emailer.vue?vue&type=script&lang=js&"
export * from "./Emailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports